import React from "react";
import { FloatingLabel, Form, InputGroup } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import MyIcon from "../Common/MyIcon";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import NewFeature from "../Builder/Components/NewFeature";

export default function VoiceSendSettings({
  handleCommunicationDefaults,
  communicationDefaults,
  setCommunicationDefaults,
  errors,
  disabled,
}) {
  return (
    <div>
      <div>
        <>
          <h5 className="d-flex align-items-center">
            <MyIcon Icon={VoiceIcon} width={35} className="me-2" />
            <span className="ms-2">
              <span className="fw-bold me-2">Voice Send Settings:</span>
              <HelpButton helpKey="settings-voice-send-settings" />{" "}
              <div className="small text-secondary">
                These settings control options related to outbound voice
                sending.
              </div>
            </span>
          </h5>
        </>

        <hr className="my-3 text-secondary" />
        <div className="row">
          <div className="col-6">
            <FloatingLabel label="Intro Message:" className="mb-2">
              <Form.Control
                placeholder="Intro message:"
                name="VoiceIntro"
                onChange={handleCommunicationDefaults}
                value={communicationDefaults.VoiceIntro}
                as="textarea"
              />
              <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
                <HelpButton helpKey="settings-voice-send-settings-intro-message" />
              </div>
            </FloatingLabel>
            {errors.includes("voice intro is required") && (
              <div className="alert alert-danger p-1">
                Voice intro is required
              </div>
            )}
            <FloatingLabel label="Exit Message:" className="mb-2">
              <Form.Control
                placeholder="Exit Message:"
                name="VoiceExit"
                onChange={handleCommunicationDefaults}
                value={communicationDefaults.VoiceExit}
              />
              <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
                <HelpButton helpKey="settings-voice-send-settings-exit-message" />
              </div>
            </FloatingLabel>{" "}
            {errors.includes("voice exit is required") && (
              <div className="alert alert-danger p-1">
                Voice exit is required
              </div>
            )}
            <FloatingLabel label="Voice Retries:" className="mb-2">
              <div className="me-2 mt-3 position-absolute top-50 end-0 translate-middle-y">
                <HelpButton helpKey="settings-voice-send-settings-voice-retries" />
              </div>
              <Form.Select
                className="border-0"
                placeholder="Voice Retries"
                name="VoiceRetries"
                onChange={(e) =>
                  handleCommunicationDefaults({
                    target: {
                      name: "VoiceRetries",
                      value: parseInt(e.target.value),
                    },
                  })
                }
                value={communicationDefaults.VoiceRetries}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
              </Form.Select>
            </FloatingLabel>
            <NewFeature>
              <div className="mb-2">
                <InputGroup>
                  <InputGroup.Text>Max characters</InputGroup.Text>
                  <Form.Control
                    aria-label="With textarea"
                    value={communicationDefaults.maxCharacters || 1244}
                    onChange={(e) =>
                      setCommunicationDefaults((p) => ({
                        ...p,
                        maxCharacters: e.target.value,
                      }))
                    }
                  />
                </InputGroup>
              </div>
              {/* <div className="me-2 position-absolute top-50 end-0 translate-middle-y">
              <HelpButton />
            </div> */}{" "}
              <div className="mb-2">
                <InputGroup>
                  <InputGroup.Text> Retry attempts</InputGroup.Text>
                  <Form.Control
                    type="number"
                    aria-label="Retry attempts"
                    value={communicationDefaults.retryAttempts || 5}
                    onChange={(e) =>
                      setCommunicationDefaults((p) => ({
                        ...p,
                        retryAttempts: e.target.value,
                      }))
                    }
                  />
                </InputGroup>
              </div>{" "}
              <div className="bg-white p-3 rounded-3 mb-2">
                <div className="mb-2">Reply forward Options: </div>
                <div>
                  <Input
                    isMulti
                    inputType="select"
                    value={communicationDefaults.ReplyOptions || []}
                    onChange={(v) =>
                      setCommunicationDefaults((p) => ({
                        ...p,
                        ReplyOptions: v,
                      }))
                    }
                    options={[
                      { value: "boommail", label: "Boommail" },
                      { value: "Email", label: "Email" },
                      { value: "api", label: "API" },
                    ]}
                    isDisabled={disabled}
                  />
                </div>
              </div>
            </NewFeature>
          </div>
          <div className="col-6">
            <NewFeature>
              <InputGroup>
                <FloatingLabel className=" mb-2"> Voice divert </FloatingLabel>

                <Form.Check // prettier-ignore
                  type="switch"
                  id=" voiceDivert -switch"
                  name=" voiceDivert "
                  checked={communicationDefaults.voiceDivert}
                  onChange={() =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      shortLinks: !p.shortLinks,
                    }))
                  }
                />
              </InputGroup>
              <InputGroup>
                <FloatingLabel className=" mb-2">
                  Voice mail management
                </FloatingLabel>

                <Form.Check // prettier-ignore
                  type="switch"
                  id="voiceMailManagement-switch"
                  name="voiceMailManagement"
                  checked={communicationDefaults.voiceMailManagement}
                  onChange={() =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      shortLinks: !p.shortLinks,
                    }))
                  }
                />
              </InputGroup>
              <InputGroup>
                <FloatingLabel className=" mb-2"> Ai prompting</FloatingLabel>

                <Form.Check // prettier-ignore
                  type="switch"
                  id="aiPrompting-switch"
                  name="aiPrompting"
                  checked={communicationDefaults.aiPrompting}
                  onChange={() =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      aiPrompting: !p.aiPrompting,
                    }))
                  }
                />
              </InputGroup>
              <InputGroup>
                <FloatingLabel className=" mb-2">Short-links</FloatingLabel>

                <Form.Check // prettier-ignore
                  type="switch"
                  id="shortLinks-switch"
                  name="shortLinks"
                  checked={communicationDefaults.shortLinks}
                  onChange={() =>
                    setCommunicationDefaults((p) => ({
                      ...p,
                      shortLinks: !p.shortLinks,
                    }))
                  }
                />
              </InputGroup>
            </NewFeature>
          </div>
        </div>
      </div>
    </div>
  );
}
